<template>
  <div class="container">
    <div class="content">
      <h3>乐刷接口签名验证工具</h3>
      <el-form
        :model="form"
        ref="form"
        :rules="ruleData"
        label-position="left"
        label-width="90px"
        class="signatureForm"
      >
        <el-form-item label="签名类型" prop="type">
          <el-radio-group v-model="form.type" @change="()=>{showResult = false}">
            <el-radio :label="0">进件签名</el-radio>
            <el-radio :label="1">交易签名</el-radio>
            <el-radio :label="2">通知签名</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="请求串" prop="requestString">
          <el-input
            style="width:700px;"
            placeholder="请粘贴要传递的参数"
            type="textarea"
            :rows="10"
            resize="none"
            v-model="form.requestString"
            @input="()=>{showResult = false}"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户key" prop="merchantKey">
          <el-input
            style="width:700px;"
            v-model="form.merchantKey"
            @input="()=>{showResult = false}"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getSignature" type="plain">校验签名</el-button>
      </el-form-item>
      </el-form>
      <div v-if="showResult">
        <div class="signatureInfo" v-if="form.type === 0">
          <div class="title">1.data中字符串</div>
          <div class="result">{{requestValue}}</div>
          <div class="title">2.拼接字符串</div>
          <div class="result">{{signValue}}</div>
          <div class="title">3.MD5后转小写</div>
          <div class="result">{{mdValue}}</div>
          <div class="title">4.base64加密</div>
          <div class="sign"><span class="label">原sign值:</span>{{defaultSignValue}}</div>
          <div class="sign"><span class="label">新sign值:</span>{{sign}}</div>
          <div class="passed" v-if="defaultSignValue===sign">校验通过</div>
          <div class="fail" v-else>校验不通过</div>
        </div>
        <div class="signatureInfo" v-else>
          <div class="title">1.对参数按照key=value的格式，并按照参数名ASCII字典序排序如下</div>
          <div class="result">{{requestValue}}</div>
          <div class="title">2.拼接商户密key</div>
          <div class="result">{{signValue}}</div>
          <div class="title">3.计算签名(MD5后转{{form.type === 2 ? '小' : '大'}}写)</div>
          <div class="sign">原sign值:&nbsp;&nbsp;{{defaultSignValue}}</div>
          <div class="sign">新sign值:&nbsp;&nbsp;&nbsp;{{sign}}</div>
          <div class="passed" v-if="defaultSignValue===sign">校验通过</div>
          <div class="fail" v-else>校验不通过</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import md5 from 'js-md5'
export default {
  data () {
    return {
      form: {
        // 签名类型
        type: 0,
        requestString: '',
        merchantKey: ''
      },
      ruleData: {
        requestString: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入请求串'))
            } else {
              if (this.form.type === 0 && !this.isJSON(value)) {
                callback(new Error('请输入正确的JSON格式'))
              } else if (this.form.type === 1 && !this.isQs(value)) {
                callback(new Error('请输入正确的key-value格式'))
              } else if (this.form.type === 2 && !this.isXml(value)) {
                callback(new Error('请输入正确的XML格式'))
              }
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择签名类型',
          trigger: 'blur'
        }],
        merchantKey: [{
          required: true,
          message: '请输入商户key',
          trigger: 'blur'
        }]
      },
      requestValue: '',
      signValue: '',
      mdValue: '',
      defaultSignValue: '',
      sign: '',
      showResult: false,
      filterList: ['sign', 'leshua', 'resp_code']
    }
  },
  methods: {
    getSignature () {
      console.log(qs.stringify(qs.parse('a=&b=1')))
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.type === 0) {
            const requestItem = JSON.parse(this.form.requestString)
            if (requestItem.sign) {
              this.defaultSignValue = requestItem.sign
            }
            this.filterList.map(key => {
              requestItem[key] && delete requestItem[key]
            })
            this.requestValue = JSON.stringify(requestItem)
            this.signValue = 'lepos' + this.form.merchantKey + this.requestValue
            this.mdValue = md5(this.signValue)
            this.sign = btoa(this.mdValue)
          } else if (this.form.type === 1) {
            this.requestValue = this.objKeySort(qs.parse(this.form.requestString))
            this.signValue = this.requestValue + '&key=' + this.form.merchantKey
            this.sign = md5(this.signValue).toUpperCase()
          } else {
            const reg = /<([a-z_]+)><!\[CDATA\[(\S+)\]\]><\/\1>/g
            const params = {}
            let res = reg.exec(this.form.requestString)
            while (res) {
              params[res[1]] = res[2]
              res = reg.exec(this.form.requestString)
            }
            this.requestValue = this.objKeySort(params)
            this.signValue = this.requestValue + '&key=' + this.form.merchantKey
            this.sign = md5(this.signValue).toLowerCase()
          }
          this.showResult = true
        }
      })
    },
    objKeySort (arys) {
      var newkey = Object.keys(arys).sort()
      var newObj = ''
      for (var i = 0; i < newkey.length; i++) {
        if (this.filterList.includes(newkey[i])) {
          if (newkey[i] === 'sign') {
            this.defaultSignValue = arys[newkey[i]]
          }
          continue
        }
        newObj += [newkey[i]] + '=' + arys[newkey[i]] + '&'
      }
      return newObj.substring(0, newObj.length - 1)
    },
    isJSON (str) {
      if (typeof str === 'string') {
        try {
          var obj = JSON.parse(str)
          if (typeof obj === 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      }
    },
    isQs (str) {
      return /^(\w+=\S+&)*\w+=\S+$/.test(str)
    },
    isXml (str) {
      const reg = /<(\w+)><!\[CDATA\[(\S+)\]\]><\/\1>/g
      return reg.test(str)
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    background-color: #f0f2f5;
    .content{
      width:1000px;
      height:100%;
      overflow-y: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      border-radius: 11px;
      background:rgba(255,255,255,1);
      padding: 30px;
    }
  }
  .signatureForm {
    margin: 45px 0 30px 0;
  }
  .signatureInfo {
    .result {
      word-wrap:break-word;
      word-break:break-all;
      margin-bottom: 30px;
      margin-top: 5px;
    }
    .sign {
      word-wrap:break-word;
      word-break:break-all;
      margin: 5px 0;
    }
    .label {
      display: inline-block;
      width: 80px;
    }
    .passed {
      color: green;
    }
    .fail {
      color: red;
    }
  }
</style>
